<template>
  <button @click="exportTransaction" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount" :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  name: "CallFeeExport",
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/call-fee/', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            domain: item.client.domain,
            user: item.fromUser && item.fromUser.name ? item.fromUser.name : '',
            userEmail: item.fromUser && item.fromUser.email ? item.fromUser.email: '',
            ext: item.fromExt,
            fromGroup: item.fromGroup && item.fromGroup.name ? item.fromGroup.name : '',
            fromNumber: item.fromNumber,
            toNumber: item.toNumber,
            startTime: item.startTime ? moment(item.startTime).format('DD/MM/YYYY HH:mm:ss') : '',
            answerTime: item.answerTime ? moment(item.answerTime).format('DD/MM/YYYY HH:mm:ss') : '',
            endTime: item.endTime ? moment(item.endTime).format('DD/MM/YYYY HH:mm:ss') : '',
            billDuration: item.billDuration,
            chargeDuration: item.chargeDuration ? item.chargeDuration : 0,
            chargedFee: item.chargedFee,
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'call-fee.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: 'Domain', key: 'domain', width: 15},
        {header: this.$t('user'), key: 'user', width: 15},
        {header: this.$t('email'), key: 'userEmail', width: 15},
        {header: this.$t('ext'), key: 'ext', width: 15},
        {header: this.$t('group'), key: 'fromGroup', width: 15},
        {header: this.$t('fromNumber'), key: 'fromNumber', width: 15},
        {header: this.$t('toNumber'), key: 'toNumber', width: 15},
        {header: this.$t('startTime'), key: 'startTime', width: 15},
        {header: this.$t('answerTime'), key: 'answerTime', width: 15},
        {header: this.$t('endTime'), key: 'endTime', width: 15},
        {header: this.$t('billDuration'), key: 'billDuration', width: 15},
        {header: this.$t('chargeDuration'), key: 'chargeDuration', width: 15},
        {header: this.$t('chargedFee'), key: 'chargedFee', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      vi: {
        clientName: 'Tên khách hàng',
        user: 'Người dùng',
        ext: 'Nhánh',
        fromNumber: 'Gọi từ số',
        toNumber: 'Gọi tới số',
        gateway: 'Gateway',
        startTime: 'Gọi lúc',
        answerTime: 'Nghe máy lúc',
        endTime: 'Kết thúc lúc',
        billDuration: 'Thời gian đàm thoại',
        chargeDuration: 'Thời gian tính cước',
        chargedFee: 'Cước gọi',
        exportNotice: 'Dữ liệu đang được tải xuống, vui lòng đợi trong giây lát!...',
        export: 'Tải xuống',
        exportingData: 'Xuất dữ liệu',
        onOffNetwork: 'Nội/ngoại mạng',
        onNetwork: 'Nội mạng',
        offNetwork: 'Ngoại mạng'
      },
      en: {
        clientName: 'Client name',
        user: 'User',
        ext: 'Ext',
        fromNumber: 'From number',
        toNumber: 'To number',
        gateway: 'Gateway',
        startTime: 'Start time',
        answerTime: 'Answer time',
        endTime: 'End time',
        billDuration: 'Bill duration',
        chargeDuration: 'Charged duration',
        chargedFee: 'Charged fee',
        exportNotice: 'Data is being downloaded. Please wait for a few moment!...',
        export: 'Export',
        exportingData: 'Exporting data',
        onOffNetwork: 'On/off network',
        onNetwork: 'On network',
        offNetwork: 'Off network'
      },
    }
  },
}
</script>